"use strict";

var _regeneratorRuntime = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _slicedToArray = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var Canvas_1 = require("./Canvas");

var Particles_1 = require("./Particles");

var Retina_1 = require("./Retina");

var FrameManager_1 = require("./FrameManager");

var Options_1 = require("../Options/Classes/Options");

var Utils_1 = require("../Utils");

var Vector_1 = require("./Particle/Vector");

var Container =
/*#__PURE__*/
function () {
  function Container(id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;
    this.fpsLimit = 60;
    this.duration = 0;
    this.lifeTime = 0;
    this.firstStart = true;
    this.started = false;
    this.destroyed = false;
    this.paused = true;
    this.lastFrameTime = 0;
    this.zLayers = 100;
    this.pageHidden = false;
    this._sourceOptions = sourceOptions;
    this.retina = new Retina_1.Retina(this);
    this.canvas = new Canvas_1.Canvas(this);
    this.particles = new Particles_1.Particles(this);
    this.drawer = new FrameManager_1.FrameManager(this);
    this.pathGenerator = {
      generate: function generate() {
        var v = Vector_1.Vector.create(0, 0);
        v.length = Math.random();
        v.angle = Math.random() * Math.PI * 2;
        return v;
      },
      init: function init() {},
      update: function update() {}
    };
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.bubble = {};
    this.repulse = {
      particles: []
    };
    this.attract = {
      particles: []
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this.density = 1;
    this._options = new Options_1.Options();
    this.actualOptions = new Options_1.Options();

    for (var _len = arguments.length, presets = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      presets[_key - 2] = arguments[_key];
    }

    for (var _i = 0; _i < presets.length; _i++) {
      var preset = presets[_i];

      this._options.load(Utils_1.Plugins.getPreset(preset));
    }

    var shapes = Utils_1.Plugins.getSupportedShapes();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = shapes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var type = _step.value;
        var drawer = Utils_1.Plugins.getShapeDrawer(type);

        if (drawer) {
          this.drawers.set(type, drawer);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this._options.load(this._sourceOptions);

    this.eventListeners = new Utils_1.EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        return _this.intersectionManager(entries);
      });
    }
  }

  _createClass(Container, [{
    key: "play",
    value: function play(force) {
      var needsUpdate = this.paused || force;

      if (this.firstStart && !this.actualOptions.autoPlay) {
        this.firstStart = false;
        return;
      }

      if (this.paused) {
        this.paused = false;
      }

      if (needsUpdate) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.plugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                plugin = _step2$value[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      this.draw(needsUpdate || false);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.drawAnimationFrame !== undefined) {
        (0, Utils_1.cancelAnimation)()(this.drawAnimationFrame);
        delete this.drawAnimationFrame;
      }

      if (this.paused) {
        return;
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.plugins[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              plugin = _step3$value[1];

          if (plugin.pause) {
            plugin.pause();
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (!this.pageHidden) {
        this.paused = true;
      }
    }
  }, {
    key: "draw",
    value: function draw(force) {
      var _this2 = this;

      var refreshTime = force;
      this.drawAnimationFrame = (0, Utils_1.animate)()(function (timestamp) {
        if (refreshTime) {
          _this2.lastFrameTime = undefined;
          refreshTime = false;
        }

        _this2.drawer.nextFrame(timestamp);
      });
    }
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this.paused && !this.pageHidden;
    }
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      this.setPath(noiseOrGenerator, init, update);
    }
  }, {
    key: "setPath",
    value: function setPath(pathOrGenerator, init, update) {
      if (!pathOrGenerator) {
        return;
      }

      if (typeof pathOrGenerator === "function") {
        this.pathGenerator.generate = pathOrGenerator;

        if (init) {
          this.pathGenerator.init = init;
        }

        if (update) {
          this.pathGenerator.update = update;
        }
      } else {
        if (pathOrGenerator.generate) {
          this.pathGenerator.generate = pathOrGenerator.generate;
        }

        if (pathOrGenerator.init) {
          this.pathGenerator.init = pathOrGenerator.init;
        }

        if (pathOrGenerator.update) {
          this.pathGenerator.update = pathOrGenerator.update;
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.canvas.destroy();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.drawers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              drawer = _step4$value[1];

          if (drawer.destroy) {
            drawer.destroy(this);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.drawers.keys()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var key = _step5.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.destroyed = true;
    }
  }, {
    key: "exportImg",
    value: function exportImg(callback) {
      this.exportImage(callback);
    }
  }, {
    key: "exportImage",
    value: function exportImage(callback, type, quality) {
      var _a;

      return (_a = this.canvas.element) === null || _a === void 0 ? void 0 : _a.toBlob(callback, type !== null && type !== void 0 ? type : "image/png", quality);
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration() {
      return JSON.stringify(this.actualOptions, undefined, 2);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.stop();
      return this.start();
    }
  }, {
    key: "reset",
    value: function reset() {
      this._options = new Options_1.Options();
      return this.refresh();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.started) {
        return;
      }

      this.firstStart = true;
      this.started = false;
      this.eventListeners.removeListeners();
      this.pause();
      this.particles.clear();
      this.canvas.clear();

      if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
        this.intersectionObserver.observe(this.interactivity.element);
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = this.plugins[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              plugin = _step6$value[1];

          if (plugin.stop) {
            plugin.stop();
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.plugins.keys()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var key = _step7.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      this.particles.linksColors = new Map();
      delete this.particles.grabLineColor;
      delete this.particles.linksColor;
    }
  }, {
    key: "loadTheme",
    value: function () {
      var _loadTheme = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(name) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.currentTheme = name;
                _context.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadTheme(_x) {
        return _loadTheme.apply(this, arguments);
      }

      return loadTheme;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _step8$value, plugin;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.started) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.init();

              case 4:
                this.started = true;
                this.eventListeners.addListeners();

                if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
                  this.intersectionObserver.observe(this.interactivity.element);
                }

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context2.prev = 10;
                _iterator8 = this.plugins[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  _context2.next = 23;
                  break;
                }

                _step8$value = _slicedToArray(_step8.value, 2), plugin = _step8$value[1];

                if (!(plugin.startAsync !== undefined)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return plugin.startAsync();

              case 17:
                _context2.next = 20;
                break;

              case 19:
                if (plugin.start !== undefined) {
                  plugin.start();
                }

              case 20:
                _iteratorNormalCompletion8 = true;
                _context2.next = 12;
                break;

              case 23:
                _context2.next = 29;
                break;

              case 25:
                _context2.prev = 25;
                _context2.t0 = _context2["catch"](10);
                _didIteratorError8 = true;
                _iteratorError8 = _context2.t0;

              case 29:
                _context2.prev = 29;
                _context2.prev = 30;

                if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                  _iterator8.return();
                }

              case 32:
                _context2.prev = 32;

                if (!_didIteratorError8) {
                  _context2.next = 35;
                  break;
                }

                throw _iteratorError8;

              case 35:
                return _context2.finish(32);

              case 36:
                return _context2.finish(29);

              case 37:
                this.play();

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 25, 29, 37], [30,, 32, 36]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "addClickHandler",
    value: function addClickHandler(callback) {
      var _this3 = this;

      var el = this.interactivity.element;

      if (!el) {
        return;
      }

      var clickOrTouchHandler = function clickOrTouchHandler(e, pos, radius) {
        if (_this3.destroyed) {
          return;
        }

        var pxRatio = _this3.retina.pixelRatio,
            posRetina = {
          x: pos.x * pxRatio,
          y: pos.y * pxRatio
        },
            particles = _this3.particles.quadTree.queryCircle(posRetina, radius * pxRatio);

        callback(e, particles);
      };

      var clickHandler = function clickHandler(e) {
        if (_this3.destroyed) {
          return;
        }

        var mouseEvent = e;
        var pos = {
          x: mouseEvent.offsetX || mouseEvent.clientX,
          y: mouseEvent.offsetY || mouseEvent.clientY
        };
        clickOrTouchHandler(e, pos, 1);
      };

      var touchStartHandler = function touchStartHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = true;
        touchMoved = false;
      };

      var touchMoveHandler = function touchMoveHandler() {
        if (_this3.destroyed) {
          return;
        }

        touchMoved = true;
      };

      var touchEndHandler = function touchEndHandler(e) {
        var _a, _b, _c;

        if (_this3.destroyed) {
          return;
        }

        if (touched && !touchMoved) {
          var touchEvent = e;
          var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];

          if (!lastTouch) {
            lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - 1];

            if (!lastTouch) {
              return;
            }
          }

          var canvasRect = (_a = _this3.canvas.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
          var pos = {
            x: lastTouch.clientX - ((_b = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) !== null && _b !== void 0 ? _b : 0),
            y: lastTouch.clientY - ((_c = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) !== null && _c !== void 0 ? _c : 0)
          };
          clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
        }

        touched = false;
        touchMoved = false;
      };

      var touchCancelHandler = function touchCancelHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = false;
        touchMoved = false;
      };

      var touched = false;
      var touchMoved = false;
      el.addEventListener("click", clickHandler);
      el.addEventListener("touchstart", touchStartHandler);
      el.addEventListener("touchmove", touchMoveHandler);
      el.addEventListener("touchend", touchEndHandler);
      el.addEventListener("touchcancel", touchCancelHandler);
    }
  }, {
    key: "updateActualOptions",
    value: function updateActualOptions() {
      this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
      this.actualOptions.setTheme(this.currentTheme);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var availablePlugins, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _step9$value, id, plugin, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, _step10$value, drawer, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _step11$value, pathOptions, customGenerator, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _step12$value;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.actualOptions = new Options_1.Options();
                this.actualOptions.load(this._options);
                this.retina.init();
                this.canvas.init();
                this.updateActualOptions();
                this.canvas.initBackground();
                this.canvas.resize();
                this.zLayers = this.actualOptions.zLayers;
                this.duration = (0, Utils_1.getRangeValue)(this.actualOptions.duration);
                this.lifeTime = 0;
                this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 60;
                availablePlugins = Utils_1.Plugins.getAvailablePlugins(this);
                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context3.prev = 15;

                for (_iterator9 = availablePlugins[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                  _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], plugin = _step9$value[1];
                  this.plugins.set(id, plugin);
                }

                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](15);
                _didIteratorError9 = true;
                _iteratorError9 = _context3.t0;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                  _iterator9.return();
                }

              case 26:
                _context3.prev = 26;

                if (!_didIteratorError9) {
                  _context3.next = 29;
                  break;
                }

                throw _iteratorError9;

              case 29:
                return _context3.finish(26);

              case 30:
                return _context3.finish(23);

              case 31:
                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context3.prev = 34;
                _iterator10 = this.drawers[Symbol.iterator]();

              case 36:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context3.next = 44;
                  break;
                }

                _step10$value = _slicedToArray(_step10.value, 2), drawer = _step10$value[1];

                if (!drawer.init) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 41;
                return drawer.init(this);

              case 41:
                _iteratorNormalCompletion10 = true;
                _context3.next = 36;
                break;

              case 44:
                _context3.next = 50;
                break;

              case 46:
                _context3.prev = 46;
                _context3.t1 = _context3["catch"](34);
                _didIteratorError10 = true;
                _iteratorError10 = _context3.t1;

              case 50:
                _context3.prev = 50;
                _context3.prev = 51;

                if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                  _iterator10.return();
                }

              case 53:
                _context3.prev = 53;

                if (!_didIteratorError10) {
                  _context3.next = 56;
                  break;
                }

                throw _iteratorError10;

              case 56:
                return _context3.finish(53);

              case 57:
                return _context3.finish(50);

              case 58:
                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context3.prev = 61;
                _iterator11 = this.plugins[Symbol.iterator]();

              case 63:
                if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                  _context3.next = 75;
                  break;
                }

                _step11$value = _slicedToArray(_step11.value, 2), plugin = _step11$value[1];

                if (!plugin.init) {
                  _context3.next = 69;
                  break;
                }

                plugin.init(this.actualOptions);
                _context3.next = 72;
                break;

              case 69:
                if (!(plugin.initAsync !== undefined)) {
                  _context3.next = 72;
                  break;
                }

                _context3.next = 72;
                return plugin.initAsync(this.actualOptions);

              case 72:
                _iteratorNormalCompletion11 = true;
                _context3.next = 63;
                break;

              case 75:
                _context3.next = 81;
                break;

              case 77:
                _context3.prev = 77;
                _context3.t2 = _context3["catch"](61);
                _didIteratorError11 = true;
                _iteratorError11 = _context3.t2;

              case 81:
                _context3.prev = 81;
                _context3.prev = 82;

                if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                  _iterator11.return();
                }

              case 84:
                _context3.prev = 84;

                if (!_didIteratorError11) {
                  _context3.next = 87;
                  break;
                }

                throw _iteratorError11;

              case 87:
                return _context3.finish(84);

              case 88:
                return _context3.finish(81);

              case 89:
                pathOptions = this.actualOptions.particles.move.path;

                if (pathOptions.generator) {
                  customGenerator = Utils_1.Plugins.getPathGenerator(pathOptions.generator);

                  if (customGenerator) {
                    if (customGenerator.init) {
                      this.pathGenerator.init = customGenerator.init;
                    }

                    if (customGenerator.generate) {
                      this.pathGenerator.generate = customGenerator.generate;
                    }

                    if (customGenerator.update) {
                      this.pathGenerator.update = customGenerator.update;
                    }
                  }
                }

                this.particles.init();
                this.particles.setDensity();
                _iteratorNormalCompletion12 = true;
                _didIteratorError12 = false;
                _iteratorError12 = undefined;
                _context3.prev = 96;

                for (_iterator12 = this.plugins[Symbol.iterator](); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                  _step12$value = _slicedToArray(_step12.value, 2), plugin = _step12$value[1];

                  if (plugin.particlesSetup !== undefined) {
                    plugin.particlesSetup();
                  }
                }

                _context3.next = 104;
                break;

              case 100:
                _context3.prev = 100;
                _context3.t3 = _context3["catch"](96);
                _didIteratorError12 = true;
                _iteratorError12 = _context3.t3;

              case 104:
                _context3.prev = 104;
                _context3.prev = 105;

                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }

              case 107:
                _context3.prev = 107;

                if (!_didIteratorError12) {
                  _context3.next = 110;
                  break;
                }

                throw _iteratorError12;

              case 110:
                return _context3.finish(107);

              case 111:
                return _context3.finish(104);

              case 112:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[15, 19, 23, 31], [24,, 26, 30], [34, 46, 50, 58], [51,, 53, 57], [61, 77, 81, 89], [82,, 84, 88], [96, 100, 104, 112], [105,, 107, 111]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "intersectionManager",
    value: function intersectionManager(entries) {
      if (!this.actualOptions.pauseOnOutsideViewport) {
        return;
      }

      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = entries[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var entry = _step13.value;

          if (entry.target !== this.interactivity.element) {
            continue;
          }

          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "sourceOptions",
    get: function get() {
      return this._sourceOptions;
    }
  }]);

  return Container;
}();

exports.Container = Container;